(function () {
  var SECTION_SELECTOR = '.oddit-section-whos-it-for';

  function initSection(section) {
    var wrapper = section.querySelector('.oddit-section-whos-it-for__cards-wrapper');
    var cards = section.querySelectorAll('.oddit-section-whos-it-for__card');
    var dots = section.querySelectorAll('.oddit-section-whos-it-for__dot');

    if (!wrapper || cards.length === 0 || dots.length === 0) return;

    function updateActiveDot() {
      var scrollLeft = wrapper.scrollLeft;
      var wrapperWidth = wrapper.offsetWidth;
      var activeIndex = 0;
      var minDistance = Infinity;

      cards.forEach(function (card, i) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var viewCenter = scrollLeft + wrapperWidth / 2;
        var distance = Math.abs(cardCenter - viewCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = i;
        }
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle(
          'oddit-section-whos-it-for__dot--active',
          i === activeIndex
        );
      });
    }

    var dotClickHandlers = [];

    wrapper.addEventListener('scroll', updateActiveDot, { passive: true });

    dots.forEach(function (dot) {
      var handler = function () {
        var index = Number(dot.getAttribute('data-slide-index'));
        var targetCard = cards[index];
        if (!targetCard) return;

        wrapper.scrollTo({
          left: targetCard.offsetLeft,
          behavior: 'smooth'
        });
      };
      dot.addEventListener('click', handler);
      dotClickHandlers.push({ dot: dot, handler: handler });
    });

    updateActiveDot();

    /* Store references for cleanup */
    section._odditWhosItForCleanup = function () {
      wrapper.removeEventListener('scroll', updateActiveDot);
      dotClickHandlers.forEach(function (item) {
        item.dot.removeEventListener('click', item.handler);
      });
    };
  }

  function destroySection(section) {
    if (typeof section._odditWhosItForCleanup === 'function') {
      section._odditWhosItForCleanup();
      delete section._odditWhosItForCleanup;
    }
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
